import { useState } from "react";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { createFoundingClubLead } from "@/lib/api";
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export function FoundingClubForm() {
  const [club, setClub] = useState("");
  const [email, setEmail] = useState("");
  const [err, setErr] = useState<"" | "club" | "email" | "submit">("");
  const [pending, setPending] = useState(false);
  const [done, setDone] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    const cleanClub = club.trim();
    if (!cleanClub) return setErr("club");
    const cleanEmail = email.trim();
    if (!EMAIL_RE.test(cleanEmail)) return setErr("email");
    setErr("");
    setPending(true);
    try {
      await createFoundingClubLead({
        club_name: cleanClub,
        email: cleanEmail,
        source: "landing_join",
        intent: "start_team",
      });
      setClub(cleanClub);
      setEmail(cleanEmail);
      setDone(true);
    } catch {
      setErr("submit");
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="marketing-enquiry">
      <p>
        Tell us about your club. We’ll contact you to discuss what your teams
        need.
      </p>
      {done ? (
        <p
          data-testid="landing-join-success"
          className="join-success"
          aria-live="polite"
        >
          <Check size={18} strokeWidth={2.4} /> You're on the list,{" "}
          {club.trim().toLowerCase()} — we'll reach out at {email}.
        </p>
      ) : (
        <form
          onSubmit={submit}
          noValidate
          data-testid="landing-join-form"
          className="join-form"
        >
          <input
            className="join-input"
            value={club}
            disabled={pending}
            onChange={(e) => {
              setClub(e.target.value);
              setErr("");
            }}
            placeholder="club or team name"
            aria-label="club or team name"
            aria-invalid={err === "club"}
          />
          <input
            className="join-input"
            type="email"
            value={email}
            disabled={pending}
            onChange={(e) => {
              setEmail(e.target.value);
              setErr("");
            }}
            placeholder="email"
            aria-label="email"
            aria-invalid={err === "email"}
          />
          <Button
            type="submit"
            variant="primary"
            size="default"
            disabled={pending}
          >
            {pending ? "sending..." : "start your team"}{" "}
            <span aria-hidden="true" className="ml-1">
              ›
            </span>
          </Button>
          {err && (
            <p className="join-note" role="alert" style={{ flexBasis: "100%" }}>
              {err === "club"
                ? "tell us your club's name"
                : err === "email"
                  ? "enter a valid email"
                  : "we couldn't add you just now. try again."}
            </p>
          )}
        </form>
      )}
    </div>
  );
}
